import { render, staticRenderFns } from "./MainContainer copy.vue?vue&type=template&id=c50dedba&"
import script from "./MainContainer copy.vue?vue&type=script&lang=js&"
export * from "./MainContainer copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports